/* eslint-disable no-debugger */
import { getMenu } from '@/library/HttpWebClient/api/menu.api.js'

const SET_MENU = 'SET_MENU'
const SET_SELECTEDID = 'SET_SELECTEDID'
const TOGGLE_OPENFOLDER = 'TOOGLE_OPENFOLDER'
const SET_OPENFOLDER = 'SET_OPENFOLDER'

const state = {
    Menu: [],
    SelectedId: null,
    OpenFolder: []
}
const mutations = {
    [SET_MENU] (state, data) {
        state.Menu = data;
        sessionStorage.setItem('menu', JSON.stringify(data));
    },
    [SET_SELECTEDID] (state, data) {
        state.SelectedId = data;
        sessionStorage.setItem('selectedId', data);
    },
    [TOGGLE_OPENFOLDER] (state, data) {
        if (state.OpenFolder.includes(data)) {
            state.OpenFolder = state.OpenFolder.filter(item => item !== data)
        } else {
            state.OpenFolder.push(data)
        }

        sessionStorage.setItem('OpenFolder', JSON.stringify(state.OpenFolder));
    },
    [SET_OPENFOLDER] (state, data) {
        state.OpenFolder = data
        sessionStorage.setItem('OpenFolder', JSON.stringify(data));
    }
}

const actions = {
    setSelected ({ commit }, id) {
        commit(SET_SELECTEDID, id)        
    },
    toggleOpenfolder ({ commit }, id) {
        commit(TOGGLE_OPENFOLDER, id)        
    },
    setOpenfolder ({ commit }, id) {
        commit(TOGGLE_OPENFOLDER, id)        
    },
    setMenu ({ commit }, menu) {
        commit(SET_MENU, menu)
    },
    async loadMenu({ commit }) {
        const menu = sessionStorage.getItem('menu');
        
        if (menu) {
            commit(SET_MENU, JSON.parse(menu));
        } else {
            try {
                let response = await getMenu();
                if (response.data) {
                    response = new DOMParser().parseFromString(response.data, 'text/xml')
                    if (response.documentElement && response.documentElement.textContent) {
                        response = JSON.parse(response.documentElement.textContent)
                    }
                }            
                
                commit(SET_MENU, response);
            } catch (error) {
                throw ("Error") // todo: usare il throw manager
            } 
        }
        
        const selectedId = Number(sessionStorage.getItem('selectedId'));
        if (selectedId) commit(SET_SELECTEDID, selectedId)              
        
        const openFolder = sessionStorage.getItem('OpenFolder');
        if (openFolder) commit(SET_OPENFOLDER, JSON.parse(openFolder))              
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
